export type DropdownPosition = 'start' | 'end';
